


























import { TotalAssinantes } from "@/services/dashboard.service";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

@Component({})
export default class DeltaAssinantesCard extends Vue {
  totalAssinantes: number | null = null;
  deltaAssinantes: number | null = null;

  @Prop() readonly assinantes!: TotalAssinantes[];
  @Prop() readonly loading!: boolean;

  mounted() {
    this.onAssinantesChange(this.assinantes);
  }

  @Watch("assinantes")
  onAssinantesChange(val: TotalAssinantes[]) {
    this.limparAssinantes();
    if (val) {
      const preenchidos = val.filter((x) => x.totalpago);
      if (preenchidos.length > 0) {
        const ultimo = preenchidos[preenchidos.length - 1];

        this.totalAssinantes = ultimo.totalpago;
        this.deltaAssinantes = this.totalAssinantes - preenchidos[0].totalpago;
      }
    }
  }

  limparAssinantes() {
    this.totalAssinantes = this.deltaAssinantes = null;
  }
}
